export default __webpack_public_path__ + "static/media/la-regular-400.86128b71.svg";